import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Account } from './components/Account';
import { BrowserRouter as Router,Routes,Route } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Account>
        <Routes>
          <Route path="/*" element={<App />}/>
        </Routes>
      </Account>
    </Router>
  </React.StrictMode>
);

